<template>
	<section class="dim-popup-wrap" :id="`${propData.id}`">
		<section class="dim-popup-mark" @click="close"></section>
		<section class="dim-popup-content">
			<div class="button ok" @click="close">확인</div>
			<div class="text">
				{{ propData.msg }}
			</div>
		</section>
	</section>
</template>

<script>
import { popCloseAndScrollAuto } from '@/utils/UtilPopup';

export default {
	props: {
		propData: {
			// { msg : '', id: '' } 두개는 필수적으로 가져와야한다.
			type: Object,
			required: true
		}
	},
	methods: {
		close() {
			popCloseAndScrollAuto(`#${this.propData.id} .dim-popup-mark`, `#${this.propData.id} .dim-popup-content`);
		}
	}
};
</script>

<style scoped>
.dim-popup-content {
	width: 400px;
	padding: 50px 30px 120px;
}
.dim-popup-content .text {
	font-size: 2rem;
	font-family: 'NotoRegular';
	text-align: center;
}
</style>
